import React, { Component, ErrorInfo, ReactNode } from 'react';
import UnavailableError from 'pages/error/unavailable';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * Handle unexpected application errors by showing a custom message
 *
 *
 */
export class AppErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return <AppError />;
    }

    return this.props.children;
  }
}

function AppError() {
  return <UnavailableError />;
}
